import http from "@/http-common";

const BASE = "statistics/employee-menu";

class EmployeeMenuKpiService {
  getKpi(employeeId, mode, date) {
    return http.get(`${BASE}/kpi`, { params: { employeeId, mode, date } });
  }
}

export default new EmployeeMenuKpiService();
